export default __webpack_public_path__ + "static/media/step-end-inactive.20538711.png";